import React, {Component} from 'react';
import './Search.css';
import arrow from './../../../img/arrow.svg';
import SpinnerText from "../../Spinners/SpinnerForTexts/SpinnerText";
import SpinnerNumbers from "../../Spinners/SpinnerForNumbers/SpinnerNumbers";


export default class Search extends Component {

    state = {
        value: '',

        opportunityToChangeValueInputForCategories: true
    }

    valueChange = (event) => {
        this.setState({
            opportunityToChangeValueInputForCategories: false,
            value: event.target.value
        })
    }


    onClickSearch = () => {
        this.setState({
            opportunityToChangeValueInputForCategories: true,
        })

        this.props.UpdateValue(this.state.value, true);
    }

    onClickClear = () => {
        this.setState({
            opportunityToChangeValueInputForCategories: true,
        })

        this.props.UpdateValue('');
    }


    RandomValue = (ACTION) => {
        if (ACTION === 'MATH') {
            return this.props.UpdateValue('random/math', true);
        } else if (ACTION === 'TRIVIA') {
            return this.props.UpdateValue('random/trivia', true);
        } else if (ACTION === 'DATE') {
            return this.props.UpdateValue('random/date', true);
        } else if (ACTION === 'YEAR') {
            return this.props.UpdateValue('random/year', true);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( prevProps.state.value !== this.state.value && this.state.opportunityToChangeValueInputForCategories === true) {
                this.setState({
                    value: prevProps.state.value
                })
            }
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.onClickSearch();
        }
        // console.log(event.key);
        // console.log(event.charCode);
    }

    ChangeNumberOnDate = (number) => {
        const Arr = this.props.state.aNumber.text.split(' ');

        const ArrMonths = [null, 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const MonthsWith31days = ['January', 'March', 'May', 'July', 'August', 'October', 'December'];
        const MonthsWith30days = ['April', 'June', 'September', 'November'];
        const MonthsWith29days =['February'];

        let ArrDays = [];
        for (let i = 0; i <= 31; i++) {
            if( i === 1 || i === 21 || i === 31){
                ArrDays.push(`${i}st`);
            } else if( i === 2 || i === 22) {
                ArrDays.push(`${i}nd`);
            } else if ( i === 3 || i === 23 ) {
                ArrDays.push(`${i}rd`);
            } else {
                ArrDays.push(`${i}th`);
            }
        }

        let MonthWord = Arr[0];
        let MonthNumber = ArrMonths.indexOf( Arr[0] );
        let Day = ArrDays.indexOf(Arr[1]);

        /* Увеличиывем Дату на +1 */
        if ( number >= 0 && MonthsWith31days.indexOf( MonthWord ) > -1 && MonthNumber !== 12 && Day === 31 ) { /* For up number */
            return this.props.UpdateValue( `${MonthNumber + number}/1/date`);

        } else if ( number >= 0 && MonthNumber === 12 && Day === 31 ) {
            return this.props.UpdateValue( `1/1/date` );

        } else if ( number >= 0 && MonthsWith30days.indexOf( MonthWord ) > -1 && Day === 30 ) {
            return this.props.UpdateValue( `${MonthNumber + number}/1/date`);

        } else if ( number >= 0 && MonthsWith29days.indexOf( MonthWord ) > -1 && Day === 29 ) {
            return this.props.UpdateValue( `${MonthNumber + number}/1/date`);

        } else if ( number < 0 && MonthsWith31days.indexOf( MonthWord ) > -1 && Day === 1  && MonthWord !== 'March' && MonthWord !== 'January') { /* For down number */
            return this.props.UpdateValue( `${MonthNumber + number}/30/date`);

        } else if ( number < 0 && MonthsWith30days.indexOf( MonthWord ) > -1 && Day === 1 ) {
            return this.props.UpdateValue(`${MonthNumber + number}/31/date`);

        } else if ( number < 0 && MonthsWith31days.indexOf( MonthWord ) > -1 && Day === 1 && MonthWord === 'March' ) {
            return this.props.UpdateValue(`${MonthNumber + number}/29/date`);

        } else if ( number < 0 && MonthsWith29days.indexOf( MonthWord ) > -1 && Day === 1 ) {
            return this.props.UpdateValue(`${MonthNumber + number}/31/date`);

        } else if ( number < 0 && MonthsWith31days.indexOf( MonthWord ) > -1 && Day === 1 && MonthWord === 'January') {
            return this.props.UpdateValue(`12/31/date`);

        }else if ( number > 0 || number < 0) {
            return this.props.UpdateValue(`${MonthNumber}/${Day + number}/date`);
        }
    }


    onClickNumber = (ACTION) => {
        if (ACTION === 'UP') {
            if( this.props.state.aNumber.type !== '/date' && this.props.state.aNumber.type !== 'Undefined') {
                return this.props.UpdateValue(`${++this.props.state.aNumber.number}${this.props.state.aNumber.type}`)
            } else if ( this.props.state.aNumber.type === '/date' ) {
                return this.ChangeNumberOnDate( 1 );
            } else if ( this.props.state.aNumber.type === 'Undefined' ) {
                return this.props.UpdateValue('Undefined');
            }
        } else if ( ACTION === 'DOWN' ) {
            if( this.props.state.aNumber.type !== '/date' && this.props.state.aNumber.type !== 'Undefined' ) {
                return this.props.UpdateValue(`${--this.props.state.aNumber.number}${this.props.state.aNumber.type}`)
            } else if ( this.props.state.aNumber.type === '/date' ) {
                return this.ChangeNumberOnDate( -1 );
            } else if ( this.props.state.aNumber.type === 'Undefined' ) {
                return this.props.UpdateValue('Undefined');
            }
        }
    }

    render() {
        const text = this.props.state.aNumber === null ? <SpinnerText /> : this.props.state.aNumber.text;
        const numbers = this.props.state.aNumber === null ? <SpinnerNumbers />  : this.props.state.aNumber.ReNumber.map(el =>
            <span key={UniqueKey()}>{el}</span>);

        return (
            <section className="search" >
                <div  className="search_panel">
                    <div className="search_panel_title">This-website.www/</div>

                    <input value={this.state.value}
                           onChange={(event) => this.valueChange(event)}
                           type="text"
                           maxLength="30"
                           placeholder="Try it out... number/type"
                           onKeyPress={this.handleKeyPress}/>

                    <button
                        id={"Search"}
                        onClick={() => this.onClickSearch()}>Search</button>
                    <button
                        id={"Clear"}
                        onClick={() => this.onClickClear()}>Clear</button>
                </div>

                <div className="search_result">
                    <div className="search_calc">

                        <button  onClick={() => this.onClickNumber('UP')}
                                 className="button_arrow-up">
                            <img src={arrow} alt=""/></button>

                        <div className="search_calc_numbers">
                            {numbers}
                        </div>

                        <button onClick={() => this.onClickNumber('DOWN')}
                                className="button_arrow-down">
                            <img src={arrow} alt=""/></button>

                    </div>

                    <div className="search_result_describe">
                        {text}
                    </div>
                </div>

                <div className="search_result_Buttons">
                    <button onClick={ () => this.RandomValue('MATH') } className="Random_Button">Random "Math"</button>
                    <button onClick={ () => this.RandomValue('TRIVIA') } className="Random_Button">Random "Trivia"</button>
                    <button onClick={ () => this.RandomValue('DATE') } className="Random_Button">Random "Date"</button>
                    <button onClick={ () => this.RandomValue('YEAR') } className="Random_Button">Random "Year"</button>
                </div>
            </section>
        );
    }
}


const UniqueKey = () => {
    const Arr = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "a", "s", "d", "f", "g", "h",
        "j", "k", "l", "z", "x", "c", "v", "b", "n", "m", "p", "a", "s", "d", "f", "g",
        "h", "j", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

    let UniqKey = '';

    for (let i = 0; i < Arr.length; i++) {
        UniqKey = UniqKey + Math.floor(Math.random() * Arr.length);
    }

    return UniqKey;
}